'use client';

import { Toaster } from 'sonner';

export default function ToastProvider() {
  return (
    <Toaster
      position="bottom-right"
      toastOptions={{
        style: {
          background: '#1A1035',
          border: '1px solid rgba(124, 58, 237, 0.3)',
          color: '#F8F4FF',
          fontFamily: 'var(--font-plus-jakarta-sans)',
          borderRadius: '10px',
        },
      }}
      richColors
    />
  );
}